{
  "toolbar_action_disabled": "Incompatible markup element",
  "edit": "Edit",
  "delete": "Delete"
}
